import { api, formatApiError } from './api';

export async function getTimeline(days, tz) {
  try {
    const { data } = await api.get('/history/timeline', { params: { days, tz } });
    return data;
  } catch (err) {
    throw new Error(formatApiError(err));
  }
}

export async function getSummary(tz) {
  try {
    const { data } = await api.get('/history/summary', { params: { tz } });
    return data;
  } catch (err) {
    throw new Error(formatApiError(err));
  }
}

export async function getSummaryMarkdown(tz) {
  try {
    const { data } = await api.get('/history/summary.md', {
      params: { tz },
      responseType: 'text',
      transformResponse: (raw) => (typeof raw === 'string' ? raw : JSON.stringify(raw)),
    });
    return typeof data === 'string' ? data : String(data);
  } catch (err) {
    throw new Error(formatApiError(err));
  }
}

export function groupByDay(events, tz) {
  const fmtLocalKey = (iso) =>
    new Intl.DateTimeFormat('en-CA', {
      year: 'numeric', month: '2-digit', day: '2-digit', timeZone: tz,
    }).format(new Date(iso));
  const fmtHuman = (iso) =>
    new Intl.DateTimeFormat(undefined, {
      month: 'short', day: 'numeric', year: 'numeric', timeZone: tz,
    }).format(new Date(iso));

  const today = fmtLocalKey(new Date().toISOString());
  const yesterday = fmtLocalKey(new Date(Date.now() - 86400000).toISOString());

  function labelFor(k) {
    if (k === today) return 'Today';
    if (k === yesterday) return 'Yesterday';
    return fmtHuman(`${k}T12:00:00Z`);
  }

  const groups = [];
  let current = null;
  for (const e of events) {
    const k = fmtLocalKey(e.occurred_at);
    const label = labelFor(k);
    if (!current || current.label !== label) {
      current = { label, events: [] };
      groups.push(current);
    }
    current.events.push(e);
  }
  return groups;
}

export function formatLocalShort(iso, tz) {
  try {
    return new Intl.DateTimeFormat(undefined, {
      hour: 'numeric', minute: '2-digit', hour12: true, timeZone: tz,
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}
